import * as React from 'react';

const Steps: React.FC = () => {
  return (
    <section id='steps' className='bg-[#fafafa] pb-10 mx-auto'>
      <div className='flex flex-col w-auto max-w-7xl mx-auto md:flex-row'>
        {/* Step 1 */}
        <div className='flex flex-col items-center justify-center p-10'>
          {/* Card Image */}
          <div className='group'>
            <img className='w-64 object-fit' alt='' src={'/step-1-image.svg'} />
            <img
              className='relative top-[-80px] left-[190px] scale-75'
              alt=''
              src={'/step-1-qr-code.svg'}
            />
          </div>
          {/* Card Text */}
          <div className='flex flex-col items-center justify-center md:mt-10'>
            <p className='text-xl font-bold'>
              <strong>Step 1</strong>
            </p>
            <p className='mb-2 text-lg font-semibold'>Customize Content</p>
            <div className='w-3/4 text-center'>
              Create content with easy to use templates (collect visitor info,
              share knowledge and solicit feedback)
            </div>
          </div>
        </div>

        {/* Step 2 */}
        <div className='flex flex-col items-center justify-center p-10'>
          {/* Card Image */}
          <div className='group'>
            <img className='w-64 object-fit' alt='' src={'/step-2-image.svg'} />
            <img
              className='relative top-[-86px] left-[216px]'
              alt=''
              src={'/step-2-qr-code.svg'}
            />
          </div>
          {/* Card Text */}
          <div className='flex flex-col items-center justify-center'>
            <p className='text-xl font-bold'>
              <strong>Step 2</strong>
            </p>
            <p className='mb-2 text-lg font-semibold'>Place QR Codes</p>
            <div className='w-3/4 text-center'>
              Place QR Codes in important locations (exhibits, monuments, art,
              historical markers, etc.)
            </div>
          </div>
        </div>

        {/* Step 3 */}
        <div className='flex flex-col items-center justify-center p-10'>
          {/* Card Image */}
          <div className='group'>
            <img className='w-64 object-fit' alt='' src={'/step-3-image.svg'} />
          </div>
          {/* Card Text */}
          <div className='flex flex-col items-center justify-center'>
            <p className='text-xl font-bold'>
              <strong>Step 3</strong>
            </p>
            <p className='mb-2 text-lg font-semibold'>
              Analyze Visitor Behavior
            </p>
            <div className='w-3/4 text-center'>
              Collect and view engagement data (gather visitor demographics,
              contact info, and more)
            </div>
          </div>
        </div>
      </div>

      {/* Request a Demo */}
      <div className='flex flex-row items-center justify-center'>
        {/* Request Demo Button */}
        <a
          href='https://share.hsforms.com/1vQT5Dh5IQg6q5d23tBcocwr7uug'
          rel='noopener'
          target='_blank'
          className='flex flex-row rounded-full bg-[#89F5A0] text-[#333215] font-bold py-5 px-12 items-center my-6 text-xl md:self-start duration-150 hover:bg-[#333215] hover:text-[#89F5A0] hover:font-semibold hover:shadow-lg'
        >
          <span className='leading-6'>Request a Demo</span>
        </a>
      </div>
    </section>
  );
};

export default Steps;
